<span
  v-if="titleMeta"
  class="utitle"
  :class="titleMeta.className"
  v-tooltip.bottom="titleMeta.name ? { value: titleMeta.name, class: 'tt-sm' } : null"
>
  {{ titleMeta.code }}
</span>
